import { initLogin } from "./loreLogin";

function run() {
  initLogin();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
document.addEventListener("astro:page-load", run);
